import api from '@/utils/api'
import categories from '@/store/wishes/categories'

export default {
  modules: {
    categories,
  },
  state: () => ({
    products: null,
    reasons: [],
    productStates: [],
    productAdminStatuses: {},
  }),
  mutations: {
    setProducts(state, payload) {
      state.products = payload
    },
    setReasons(state, payload) {
      state.reasons = payload
    },
    setProductStates(state, payload) {
      state.productStates = payload
    },
    setProductAdminStatuses(state, payload) {
      state.productAdminStatuses = payload
    },
  },
  getters: {
    getProductStateByKey: state => {
      return key => {
        return state.productStates.find(x => x.value === key).title
      }
    },
    getProductAdminStatusByKey: state => {
      return key => {
        return state.productAdminStatuses[key] || ''
      }
    },
    productStatesTransformed: state => {
      return state.productStates.map(item => {
        return {
          key: item,
          label: item,
        }
      })
    },
    productAdminStatusesTransformed: state => {
      return Object.entries(state.productAdminStatuses).map(([key, value]) => {
        return {
          key: key,
          label: value,
        }
      })
    },
    getTotalProducts(state){
      return state.products?.meta.total
    },
  },
  actions: {
    async fetchProducts({commit}, params) {
      if (params?.admin_status === 'Любой') {
        delete params.admin_status
      }

      if (params?.search === '') {
        delete params.search
      }
      if (params?.search_phone === '') {
        delete params.search_phone
      }
      if (params?.search_username === '') {
        delete params.search_username
      }
      const res = await api.http.get('/admin/products', {params: params})

      commit('setProducts', res?.data)
    },

    async fetchProduct(_, id) {
      const res = await api.http.get(`admin/products/${id}`)
      return res?.data?.data
    },

    async approveProduct(_, id) {
      await api.http.post(`admin/products/${id}/approve`)
    },

    async discardProduct(_, {id, form}) {
      await api.http.post(`admin/products/${id}/discard`, form)
    },

    async fetchReasons({commit}, params) {
      const res = await api.http.get('admin/products/reasons', {params})
      commit('setReasons', res?.data?.data)
    },

    async fetchProductStates({commit}) {
      const res = await api.http.get('admin/products/states')
      commit('setProductStates', res?.data)
    },

    async changeProductTopStatus(_, {id, params}) {
      const res = await api.http.put(`admin/products/${id}/top`, params)
      return res?.data?.data
    },

    async changeProductRecommendStatus(_, {id, params}) {
      const res = await api.http.put(`admin/products/${id}/recommended`, params)
      return res?.data?.data
    },

    async changeProductPosition(_, {id, params}) {
      const res = await api.http.put(`admin/products/${id}/position`, params)
      return res?.data?.data
    },

    async fetchProductAdminStatuses({commit}) {
      const res = await api.http.get('admin/products/admin-statuses')
      commit('setProductAdminStatuses', res?.data)
    },

    async fetchProductsByUserSlug(_, userSlug) {
      const res = await api.http.get(`/admin/products/${userSlug}/user-products-by-slug`)
      return res?.data.data
    },

    async takeMutex(_, id) {
      await api.http.post(`admin/products/${id}/mutex`)
    },

    async leaveMutex(_, id) {
      await api.http.delete(`admin/products/${id}/mutex`)
    },

    async updateProduct(_, {id, form}) {
      const formClone = {...form}
      formClone.images = formClone.images.map(x => x.id)

      if(formClone.category_id !== formClone.category?.[formClone.category.length -1] && Array.isArray(formClone.category)) {
        formClone.category_id = formClone.category[formClone.category.length -1]
      }

      await api.http.post(`admin/products/${id}`, formClone)
    },

    async saveAdminStatus(_, {id, status}) {
      await api.http.post(`admin/products/${id}/change-status`, {'admin_status': status})
    },

    async deleteProduct(_, id) {
      return await api.http.delete(`admin/products/${id}`)
    },

    async transferProductToContractor(_, id) {
      let rsp = await api.http.post(`admin/products/${id}/transfer`);
      return rsp.data
    },

    async changeContractorContent(_, id) {
      let rsp = await api.http.post(`admin/products/${id}/change-content`);
      return rsp.data
    },

    async saveProductCity(_, {productId, cityId}) {
      let {data} = await api.http.post(`admin/products/${productId}/${cityId}/save`)
      return data.data
    },

    async saveProductTopics(_, {productId, topics}) {
      let {data} = await api.http.put(`admin/products/${productId}/topics`, {topics})
      return data.data
    },

    async saveAttributes(_, {productId, attributes}) {
      let {data} = await api.http.put(`admin/products/${productId}/attributes`, {attributes})
      return data.data
    },
  },
  namespaced: true,
}
